import { render, staticRenderFns } from "./HeaderContacts.vue?vue&type=template&id=6e0f0a52&scoped=true&"
import script from "./HeaderContacts.vue?vue&type=script&lang=js&"
export * from "./HeaderContacts.vue?vue&type=script&lang=js&"
import style0 from "./HeaderContacts.vue?vue&type=style&index=0&id=6e0f0a52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0f0a52",
  null
  
)

export default component.exports